import React from 'react';

function Footer() {
  return (
    <footer>
      <p>© {new Date().getFullYear()} Griffith & McKee. All rights reserved.</p>
    </footer>
  );
}

export default Footer;